export { default } from './Tag'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Tag/index.js